import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxGym from '../../util/remote/ajaxGym';

const initialState = { 
    GymCustomerListing: null,
    GymCustomerCount: '...',
    metaData: null,
    currentPage: 1,
    mounted: false,
    payeeSearchList: null,
    searchHint: '',
    selectedGymCustomer: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'CLEAR':
      return { initialState};  // Reset state completely
    default:
      return {...state, [action.type]: action.payload};
    }
};


const GymCustomerContext = createContext();

export const GymCustomerProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

   useEffect(()=>{
      if(state.mounted){
        getGymCustomers(false, true);
      }
    }, [state.currentPage])

  const getGymCustomerCount = async () => {
    const server_response  = await ajaxGym.fetchCustomerCount();
    if(server_response.status === "OK"){
        dispatch({ type: 'GymCustomerCount', payload: server_response.details.total_p });
    }
  };

  const getGymCustomers = async (refresh=false, nextPage=false) => {

    dispatch({ type: "mounted", payload: true });

    if(!refresh && Array.isArray(state.GymCustomerListing) && !nextPage){
      return
    }

      dispatch({ type: 'GymCustomerListing', payload: null });
      const server_response  = await ajaxGym.fetchCustomerListing({page: refresh? 1:  state.currentPage});
      if(server_response.status === "OK"){
          dispatch({ type: 'GymCustomerListing', payload: server_response.details.data });
          dispatch({ type: 'metaData', payload: server_response.details.meta });
      }else{
        dispatch({ type: 'GymCustomerListing', payload: "404" });
        dispatch({ type: 'metaData', payload: "404" });
      }
  };


  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }

  const setSelectedGymCustomer = (GymCustomer)=>{
    dispatch({ type: 'selectedGymCustomer', payload: GymCustomer });
  }

  return(
    <GymCustomerContext.Provider value={{
      ...state, 
      dispatch, 
      getGymCustomerCount,
      getGymCustomers,
      setCurrentPage,
      setSelectedGymCustomer
      }}>
      {children}
    </GymCustomerContext.Provider>
  )

}

export const useGymCustomer = ()=>useContext(GymCustomerContext);

